import React, { Component } from 'react'
import Logo from '../Logo'
import { NavLink } from 'react-router-dom'

export class SideBar extends Component {
  render() {
    return (
      <div className='min-w-[260px] w-[260px] h-screen bg-white'>
        <div className='w-[260px] h-screen bg-white overflow-auto fixed shadow'>
           <div className='mt-[20px]'>
                <Logo />
           </div>
           <nav>
            <ul className='pl-[20px] pr-[20px] mt-[40px] flex flex-col gap-[4px]'>
                <li >
                    <NavLink to={'/'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>About</NavLink>
                </li>
                <li>
                    <NavLink to={'/about-founder'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>About Founder</NavLink>
                </li>
                <li>
                    <NavLink to={'/activities'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Activities</NavLink>
                </li>
               
                <li>
                    <NavLink to={'/content'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Content</NavLink>
                </li>
                <li>
                    <NavLink to={'/donates'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Donates</NavLink>
                </li>
                <li>
                    <NavLink to={'/focus-areas'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Focus Areas</NavLink>
                </li>
          
                <li>
                    <NavLink to={'/projects'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Projects</NavLink>
                </li>
                <li>
                    <NavLink to={'/volunteering'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Volunteering</NavLink>
                </li>
          
                <li>
                    <NavLink to={'/language'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Dil</NavLink>
                </li>
                <li>
                    <NavLink to={'/profile'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Profile</NavLink>
                </li>
            </ul>
           </nav>
        </div>
      </div>
    )
  }
}

export default SideBar